import ApiClient from './apiClient';
import AuthApi from './authApi';
import CasesApi from './casesApi';
import PaymentsApi from './paymentsApi';
import AccountApi from './accountApi';

class ApiService {
  constructor(baseURL) {
    this.client = new ApiClient(baseURL);

    // modular sub-APIs
    this.auth = new AuthApi(this.client);
    this.cases = new CasesApi(this.client);
    this.payments = new PaymentsApi(this.client);
    this.account = new AccountApi(this.client);
  }

  // maintain the flat API surface for existing code
  setToken(token) {
    this.client.setToken(token);
  }

  // Auth
  register(payload) {
    return this.auth.register(payload);
  }

  async login(payload) {
    return this.auth.login(payload);
  }

  getProfile() {
    return this.auth.getProfile();
  }

  verifyEmail(token) {
    return this.auth.verifyEmail(token);
  }

  logout() {
    this.client.setToken(null);
  }

  // Account
  getAccount() {
    return this.account.getAccount();
  }

  updateAccount(payload) {
    return this.account.updateAccount(payload);
  }

  // Cases
  createCase(formData) {
    return this.cases.createCase(formData);
  }

  getCases() {
    return this.cases.getCases();
  }

  getCaseTypes() {
    return this.cases.getCaseTypes();
  }

  getCaseById(id) {
    return this.cases.getCaseById(id);
  }

  getAllCases() {
    return this.cases.getAllCases();
  }

  updateCase(caseId, caseData) {
    return this.cases.updateCase(caseId, caseData);
  }

  cancelCase(caseId) {
    return this.cases.cancelCase(caseId);
  }

  // Payments
  createSetupIntent(userId) {
    return this.payments.createSetupIntent(userId);
  }

  addPaymentMethod(userId, paymentMethodId) {
    return this.payments.addPaymentMethod(userId, paymentMethodId);
  }

  getPaymentMethods(userId) {
    return this.payments.getPaymentMethods(userId);
  }

  createPaymentIntent(payload) {
    return this.payments.createPaymentIntent(payload);
  }

  deletePaymentMethod(paymentMethodId, userId) {
    return this.payments.deletePaymentMethod(paymentMethodId, userId);
  }
}

// Determine base URL from environment variable (Create React App env vars must be prefixed with REACT_APP_)
const DEFAULT_API_BASE = 'https://www.briefly-service-dev.com';
// Use direct process.env so Create React App inlines the value at build time.
const resolvedBase = process.env.REACT_APP_API_BASE_URL || DEFAULT_API_BASE;

// Export singleton instance (preserves previous import surface)
const api = new ApiService(resolvedBase);
export default api;
